import React from 'react';

/**
 * Brand logo for قِمَم. Uses a TRANSPARENT-background PNG so the logo
 * blends seamlessly with whatever surface it sits on (sidebar, header, login).
 * Sized via the `size` prop (number, in pixels). Defaults to 32.
 */
export default function BrandLogo({ size = 32, className = '' }) {
  return (
    <img
      src="/qimam-logo-192.png"
      alt="قِمَم"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-logo"
    />
  );
}
